module.exports = __webpack_public_path__ + "img/simulatorProject.84433692.svg";